// function getChar(e) {
//     /*** Convert to Char Code ***/
//     //var code = e.which;
//     var code = keyCode;

//     //Ignore Shift Key events & arrows
//     var ignoredCodes = {
//         16: true,
//         37: true,
//         38: true,
//         39: true,
//         40: true,
//         20: true,
//         17: true,
//         18: true,
//         91: true
//     };

//     if (ignoredCodes[code] === true) {
//         return false;
//     }

//     //These are special cases that don't fit the ASCII mapping
//     var exceptions = {
//         186: 59, // ;
//         187: 61, // =
//         188: 44, // ,
//         189: 45, // -
//         190: 46, // .
//         191: 47, // /
//         192: 96, // `
//         219: 91, // [
//         220: 92, // \
//         221: 93, // ]
//         222: 39, // '
//         //numeric keypad
//         96: '0'.charCodeAt(0),
//         97: '1'.charCodeAt(0),
//         98: '2'.charCodeAt(0),
//         99: '3'.charCodeAt(0),
//         100: '4'.charCodeAt(0),
//         101: '5'.charCodeAt(0),
//         102: '6'.charCodeAt(0),
//         103: '7'.charCodeAt(0),
//         104: '8'.charCodeAt(0),
//         105: '9'.charCodeAt(0)
//     };

//     if (exceptions[code] !== undefined) {
//         code = exceptions[code];
//     }

//     var ch = String.fromCharCode(code);

//     /*** Handle Shift ***/
//     if (e.shiftKey) {
//         var special = {
//             1: '!',
//             2: '@',
//             3: '#',
//             4: '$',
//             5: '%',
//             6: '^',
//             7: '&',
//             8: '*',
//             9: '(',
//             0: ')',
//             ',': '<',
//             '.': '>',
//             '/': '?',
//             ';': ':',
//             "'": '"',
//             '[': '{',
//             ']': '}',
//             '\\': '|',
//             '`': '~',
//             '-': '_',
//             '=': '+'
//         };

//         if (special[ch] !== undefined) {
//             ch = special[ch];
//         }
//     }
//     else {
//         ch = ch.toLowerCase();
//     }

//     return ch.charCodeAt(0);
// }
export function convertChar(e) {

    if (e.code.search("Key") === -1) {
        return;
    }
    e.preventDefault();
    // document.getElementById("demo").innerHTML = unicode;
    // console.log("plg ", getChar(e), String.fromCharCode(getChar(e)));
    // //Do nothing for ASCII chars
    // if (charCode < 255)//0x00FF
    //     return;
    let key = e.code.replace("Key", "");
    if (!e.getModifierState('CapsLock')) {
        key = key.toLowerCase();
    }
    e.target.value += key; //String.fromCharCode(getChar(e));




}
export function toEnglishNumber(e) {
    e.preventDefault();
    var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    var cache = e.target.value;
    for (var i = 0; i < 10; i++) {
        var regex_fa = new RegExp(pn[i], 'g');
        cache = cache.replace(regex_fa, en[i]);
    }
    e.target.value = cache;
}